import React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import avatar from "./avatar.jpg";

const App = () => {
  const items = [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/eidsonsa",
    },
    {
      name: "github",
      url: "https://github.com/eidsonsa",
    },
    {
      name: "email",
      url: "mailto:eidsonsa@gmail.com",
    },
  ];

  return (
    <Box
      display="flex"
      justifyContent="center"
      mt={10}
      alignItems="center"
      flexDirection="column"
    >
      <Typography
        variant="h4"
        sx={{
          animation: "slideInLeft 0.8s ease-out 0.2s both",
          "@keyframes slideInLeft": {
            "0%": {
              transform: "translateX(-100px)",
              opacity: 0,
            },
            "100%": {
              transform: "translateX(0)",
              opacity: 1,
            },
          },
        }}
      >
        eidson sá
      </Typography>
      <Avatar alt="Eidson Sá" src={avatar} sx={{ width: 200, height: 200 }} />
      {items.map((item, index) => (
        <Typography
          key={item.name}
          variant="h4"
          component="a"
          href={item.url}
          target="_blank"
          sx={{
            cursor: "pointer",
            color: "inherit",
            textDecoration: "underline",
            transition: "all 0.3s ease-in-out",
            animation: `slideInLeft 0.8s ease-out ${1 + index * 0.3}s both`,
            "@keyframes slideInLeft": {
              "0%": {
                transform: "translateX(-100px)",
                opacity: 0,
              },
              "100%": {
                transform: "translateX(0)",
                opacity: 1,
              },
            },
            "&:hover": {
              transform: "translateY(-2px)",
              color: "primary.main",
              textShadow: "0 2px 4px rgba(0,0,0,0.1)",
            },
          }}
        >
          {item.name}
        </Typography>
      ))}
    </Box>
  );
};

export default App;
